import React from 'react';

const TemplateColorSwatchCell = ({ color }) => (
    <div
        style={{
            position: 'relative',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '25px',
            width: '25px',
            backgroundColor: color,
        }}
    >
    </div>
);

export default TemplateColorSwatchCell;
